import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { getInvoicesIssuedForPayments } from "../../api/NetworkingInvoice";
import AppContext from "../../App.context";
import { getResource } from "../../helpers/ResourcesHelper";
import Button from "../inputs/Button";
import { Disbursement } from "../models/Disbursement";
import { Invoice } from "../models/Invoice";
import { OrderOneStepScreenType } from "../orders_onestep/OrderOneStepScreen";

const invoicesColumns: ColumnsType<Invoice> = [
  {
    title: 'Beneficiary',
    dataIndex: 'beneficiaryName',
    sorter: (a, b) => (b.beneficiaryName || '').localeCompare(a.beneficiaryName),
    align: 'center',
    width: '25%'
  },
  {
    title: 'ID',
    dataIndex: 'invoiceIssuedId',
    align: 'right'
  },
  {
    title: 'Number',
    dataIndex: 'invoiceNumber',
    align: 'right'
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    align: 'right'
  },
  {
    title: 'Currency',
    dataIndex: 'currencyId',
    sorter: (a, b) => (b.currencyId || '').localeCompare(a.currencyId),
    align: 'left'
  },
  {
    title: 'Date',
    dataIndex: 'invoiceDate',
    sorter: (a, b) => (b.invoiceDate || '').localeCompare(a.invoiceDate),
  },
  {
    title: 'Description',
    dataIndex: 'invoiceDescription',
    width: '25%'
  },
  {
    title: 'QB Ref',
    dataIndex: 'qBRefNo'
  },
];

const InvoicesPayForm = (props: any) => {

  const { payBenes } = props

  const { showLoadingModal, hideLoadingModal } = useContext(AppContext);

  const customerId = JSON.parse(localStorage.getItem('UserSession')!)['CustomerID'];
  const [invoices, setInvoices] = useState<Invoice[]>()
  const [selectedInvoices, setSelectedInvoices] = useState<Invoice[]>([])
  const [buyCurrency, setBuyCurrency] = useState('')

  useEffect(() => {
    const load = async () => {
      showLoadingModal()
      let jsonResponse = await getInvoicesIssuedForPayments(customerId)
      hideLoadingModal()
      console.log('getInvoicesIssuedForPayments', jsonResponse)
      let invoices: Invoice[] = []
      if (jsonResponse.InvoicesToPay !== undefined) {
        jsonResponse.InvoicesToPay.forEach((inv: any) => {
          let invoice: Invoice = {
            amount: inv.Amount,
            bankAccountId: inv.BankAccountId,
            beneficiaryId: inv.BeneficiaryID,
            beneficiaryName: inv['Beneficiary Name'],
            currencyId: inv.CurrencyId,
            invoiceDate: inv.InvoiceDate,
            invoiceDescription: inv.InvoiceDescription,
            invoiceIssuedId: inv.InvoiceIssuedId,
            invoiceNumber: inv.InvoiceNumber,
            key: inv.InvoiceIssuedId,
            qBRefNo: inv.QBRefNo,
            status: inv.Status
          }
          invoices.push(invoice)
        });
      }
      setInvoices(invoices)
    }
    load();
  }, [customerId]);

  const payInvoices = () => {
    let disbursements = selectedInvoices.map((inv, idx) => {
      let d: Disbursement = {
        amount: Number(inv.amount),
        bankAccountId: inv.bankAccountId,
        beneficiaryId: inv.beneficiaryId,
        instrument: '',
        otherAmount: 0,
        key: `{b.BeneficiaryID} - {b.bankAccountId}`,
        lineNumber: idx,
        invoiceIssuedId: inv.invoiceIssuedId,
        entityProperties: [],
        showProperties: false
      }
      return d;
    })
    let payInfo: OrderOneStepScreenType = {
      disbursements: disbursements,
      buyCurrency: buyCurrency,
      lockedSide: 'buy',
      disbursementInfoAsParameter: true
    }
    payBenes(payInfo);
  }

  return <>
    <div className="title-text"><h2>{getResource('PayInvoices')}</h2></div>
    <div className="col-md-12 col-xs-12">
      <Table
        rowSelection={{
          type: 'checkbox',
          onChange: (selectedRowKeys: React.Key[], selectedRows: Invoice[]) => {
            setSelectedInvoices(selectedRows)
            if (selectedRows.length > 0) {
              setBuyCurrency(selectedRows[0].currencyId)
            } else {
              setBuyCurrency('')
            }
          },
          getCheckboxProps: (record: Invoice) => ({
            disabled: record.bankAccountId === 0 || (buyCurrency !== '' && record.currencyId !== buyCurrency),
          })
        }}
        columns={invoicesColumns}
        dataSource={invoices}
      />
    </div>
    <div className='row-actions'>
      <Button type="primary" disabled={selectedInvoices.length === 0} onClick={payInvoices}>Pay Invoices</Button>
    </div>
  </>
}

export default InvoicesPayForm